import { CaretLeft, CaretRight, CalendarBlank } from '@phosphor-icons/react';
import { addMonths, format, parseISO } from 'date-fns';

export const VIEW_OPTIONS = [
  { key: 'both', label: 'Lined up or Joining' },
  { key: 'interview_date', label: 'Lined up (Interview)' },
  { key: 'date_of_joining', label: 'Joining month' },
];

export const shiftMonth = (month, delta) => format(addMonths(parseISO(`${month}-01`), delta), 'yyyy-MM');

export const MonthBar = ({ month, setMonth, monthView, setMonthView, currentMonth }) => {
  const label = month ? format(parseISO(`${month}-01`), 'MMMM yyyy') : 'All months';
  const btn = 'p-2 bg-white text-black border-2 border-black rounded-md hover:-translate-y-0.5 hover:shadow-[2px_2px_0px_0px_rgba(10,10,10,1)] transition-all disabled:opacity-40 disabled:hover:translate-y-0';
  return (
    <div className="mb-3 flex flex-wrap items-center gap-3 bg-[#0F3622] border-2 border-[#FDE047] rounded-md p-3" data-testid="month-bar">
      <div className="flex items-center gap-2">
        <button data-testid="month-prev" className={btn} disabled={!month} onClick={() => setMonth(shiftMonth(month, -1))} title="Previous month">
          <CaretLeft size={18} weight="bold" />
        </button>
        <div className="flex items-center gap-2 bg-[#FDE047] text-black border-2 border-black rounded-md px-4 py-2 min-w-[190px] justify-center">
          <CalendarBlank size={18} weight="fill" />
          <span className="font-black text-sm uppercase tracking-wider" data-testid="month-label">{label}</span>
        </div>
        <button data-testid="month-next" className={btn} disabled={!month} onClick={() => setMonth(shiftMonth(month, 1))} title="Next month">
          <CaretRight size={18} weight="bold" />
        </button>
        <input
          data-testid="month-input"
          type="month"
          value={month}
          onChange={(e) => setMonth(e.target.value)}
          className="bg-white border-2 border-black rounded-md px-2 py-1.5 text-black font-bold text-sm"
        />
      </div>
      <div className="flex items-center gap-1 flex-wrap" data-testid="month-view-toggle">
        {VIEW_OPTIONS.map((o) => (
          <button
            key={o.key}
            data-testid={`month-view-${o.key}`}
            onClick={() => setMonthView(o.key)}
            className={`px-3 py-1.5 rounded-md border-2 border-black text-xs font-bold transition-all ${monthView === o.key ? 'bg-[#A3E635] text-black' : 'bg-white/10 text-white hover:bg-white/20'}`}
          >
            {o.label}
          </button>
        ))}
      </div>
      <div className="ml-auto flex gap-2">
        {month !== currentMonth && (
          <button data-testid="month-today" onClick={() => setMonth(currentMonth)} className="px-3 py-1.5 bg-[#93C5FD] text-black border-2 border-black rounded-md text-xs font-bold hover:-translate-y-0.5 transition-all">
            This month
          </button>
        )}
        <button data-testid="month-all" onClick={() => setMonth(month ? '' : currentMonth)} className="px-3 py-1.5 bg-white text-black border-2 border-black rounded-md text-xs font-bold hover:-translate-y-0.5 transition-all">
          {month ? 'Show all' : 'Back to monthly'}
        </button>
      </div>
    </div>
  );
};
